import { formatTime } from "@/helpers/time/time.helpers";
import { Typography, useAudio } from "@aircall/tractor";

export function PlayerDuration() {
  const { duration } = useAudio();

  return (
    <Typography
      variant="bodyMediumS"
      color="text-placeholder"
      userSelect="none"
      data-test="player-duration-display"
    >
      {formatTime(duration)}
    </Typography>
  );
}
